import { render, staticRenderFns } from "./ResponsiveText.vue?vue&type=template&id=51deb5fe&scoped=true&"
import script from "./ResponsiveText.vue?vue&type=script&lang=js&"
export * from "./ResponsiveText.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveText.vue?vue&type=style&index=0&id=51deb5fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51deb5fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
